<template>
  <section class="Levels" id="Levels">
    <div class="levels_wrapper">
      <h1 class="title light">
        <span>
          Niveles Educativos
        </span>
      </h1>
      <h2> Participación comprometida de los padres de familia y la sociedad Civil organizada, en los procesos educativos de los estudiantes. </h2>
      <div class="levels_grid">
        <article id="level_default">
          <div class="image_hover">
            <div class="video_cover">
              <img src="@/assets/img/level_1.png" alt="inicial">
            </div>
          </div>
          <div class="level_item_box">
            <h1> INICIAL </h1>
            <div class="play_button" @click="openModal(2)">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                <path d="M15 8.55909L0.450607 16.5774L0.450608 0.540815L15 8.55909Z" fill="#34498B"/>
              </svg>
            </div>
          </div>
        </article>
        <article>
          <div class="image_hover">
            <div class="video_cover" >
              <img src="@/assets/img/level_2.png" alt="primaria">
            </div>
          </div>
          <div class="level_item_box">
            <h1> PRIMARIA </h1>
            <div class="play_button" @click="openModal(3)">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                <path d="M15 8.55909L0.450607 16.5774L0.450608 0.540815L15 8.55909Z" fill="#34498B"/>
              </svg>
            </div>
          </div>
        </article>
        <article>
          <div class="image_hover">
            <div class="video_cover">
              <img src="@/assets/img/level_3.png" alt="secundaria">
            </div>
          </div>
          <div class="level_item_box">
            <h1> SECUNDARIA </h1>
            <div class="play_button" @click="openModal(4)">
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                <path d="M15 8.55909L0.450607 16.5774L0.450608 0.540815L15 8.55909Z" fill="#34498B"/>
              </svg>
            </div>
          </div>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Levels',
  mounted () {
    window.addEventListener('scroll', () => {
      const levels = document.getElementById('Levels')
      const firstChild = document.getElementById('level_default')
      let top = document.documentElement.scrollTop
      let height = document.documentElement.clientHeight

      if ( top + (height / 1.2) > levels.offsetTop + (levels.clientHeight / 2) ) {
        levels.classList.add('trigger')
        setTimeout(() => {
          firstChild.classList.add('trigger')
        }, 800);
      }
    })
      // header.classList.add('trigger')
  },
  methods: {
    openModal (section) {
      this.$emit('openModal', section)
    },
    getVideoId (url) {
      const code = url.match(/v=([^&#]{5,})/)
      return (typeof code[1] == 'string') ? code[1] : false;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
@import '../assets/css/app.sass'
.Levels
  width: 980px
  margin: 0 auto
  padding: 7rem 70px
  box-sizing: border-box
  .levels_wrapper
    .title
      // margin-top: 20px
      position: relative
      height: 30px
      span
        position: absolute
        left: 0
        top: 0
        transition: all ease-in-out .3s .7s
    h2
      color: $primary_color
      opacity: 0.8
      font-size: 15px
      font-family: $font_text
      line-height: 1.7
      margin-top: 20px
      max-width: 400px
      width: 100%
      transition: all ease-in-out .5s .9s
    .levels_grid
      width: 100%
      display: grid
      grid-template-columns: 1fr 1fr 1fr
      margin-top: 20px
      position: relative
      article
        height: 300px
        background-color: $accent_color
        position: relative
        &:last-child
         z-index: 5
        &:hover
          .level_item_box
            .play_button
              svg path
                fill: $primary_color !important
          .image_hover
            .video_cover
              transition: all ease-in-out .3s
              // animation: reveal_scale .3s .2s forwards alternate
              transform: scaleY(1)
              &:before, &:after
                animation: reveal_square .3s .2s forwards
                transition: all ease-in-out .3s
              img
                transition: all ease-in-out .4s
                animation: reveal_belt .4s .4s forwards alternate
        &:nth-child(1)
          .level_item_box
            .play_button
              svg path
                fill: $accent_color
        &:nth-child(2)
          background-color: $secondary_color
          .level_item_box
            .play_button
              svg path
                fill: $secondary_color
          .image_hover
            .video_cover
              &:before, &:after
                background-color: $secondary_color
        &:nth-child(3)
          background-color: $primary_color
          .image_hover
            .video_cover
              &:before, &:after
                background-color: $primary_color
        .level_item_box
          display: flex
          justify-content: center
          align-items: center
          height: 100%
          flex-direction: column
          z-index: 4
          position: relative
          h1
            color: white
            font-family: $font
            font-weight: 700
            letter-spacing: 1px
          .play_button
            width: 36px
            height: 36px
            border-radius: 50%
            background-color: white
            display: flex
            justify-content: center
            align-items: center
            z-index: 3
            margin-top: 20px
            cursor: pointer
            svg
              width: 8px
        .image_hover
          width: 100%
          height: 100%
          position: absolute
          left: 0
          top: 0
          display: flex
          justify-content: center
          align-items: center
          .video_cover
            height: 200px
            width: 200px
            transform: scaleY(0)
            transform-origin: top
            background-color: $primary_light_color
            box-shadow: 0 4px 25px 2px rgba(black, .1)
            display: flex
            justify-content: center
            align-items: center
            position: relative
            &:before, &:after
              position: absolute
              content: ''
              top: 0
              left: 0
              width: 12px
              height: 0
              background-color: $accent_color
              z-index: 10
            &:after
              left: inherit
              top: inherit
              bottom: 0
              right: 0
            img
              display: block
              object-fit: cover
              width: 200px
              height: 0
              max-height: 200px
              opacity: .7

@media screen and (max-width: 980px)
  .Levels
    width: 760px
    padding: 5rem 70px
    .levels_wrapper
      h2
        font-size: 13px
        margin-top: 0
      .levels_grid
        article
          height: 220px
          .level_item_box
            h1
              font-size: 14px
          .image_hover
            .video_cover
              height: 150px
              width: 150px
              img
                width: 150px
                max-height: 150px

@media screen and (max-width: 760px)
  .Levels
    width: 480px
    padding: 5rem 0
    .levels_wrapper
      h2
        width: 320px
      .levels_grid
        grid-template-columns: 1fr 1fr
        article
          &:nth-child(2)
            grid-column: 2 / span 2
            grid-row: 2
          &:nth-child(3)
            grid-column: 1
            grid-row: 3 / span 1

@media screen and (max-width: 560px)
  .Levels
    width: 320px
    .levels_wrapper
      h2
        width: 100%
      .levels_grid
        grid-template-columns: 1fr
        article
          &:nth-child(2),  &:nth-child(3)
            grid-column: initial
            grid-row: initial
          .image_hover
            .video_cover
              width: calc(100% - 80px)
              img
                width: 100%

@media screen and (max-width: 400px)
  .Levels
    width: 100%
    padding:
      left: 40px
      right: 40px
    box-sizing: border-box
</style>
